<template>
  <div>
    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <p v-if="state.noData">No Data</p>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <h2>Laporan Claim Tanpa Nomor Laporan</h2>
      <table width="100%" class="mb-2">
        <thead>
          <th>No</th>
          <th>Tanggal</th>
          <th>No Pelunasan</th>
          <th>Nominal</th>
          <th>Kategori</th>
          <th>Keterangan</th>
        </thead>
        <tbody>
          <tr v-for="(claim, i) in data" :key="claim.id">
            <td>{{ i + 1 }}</td>
            <td>{{ formatDate(claim.created_at) }}</td>
            <td>{{ claim.no_pelunasan }}</td>
            <td>{{ formatCurrency(claim.total) }}</td>
            <td>{{ claim.kategori }}</td>
            <td>{{ claim.Keterangan }}</td>
          </tr>
        </tbody>
      </table>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: false
      },
      data: {}
    };
  },
  methods: {
    printDocument() {
      window.print();
    },
    async fetchData() {
      this.state.loading = true;

      await axios
        .get(`pelunasan/laporan-claim-tanpa-no-lk`)
        .then(res => {
          if (res.data.length <= 0) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }

          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.report .report-title {
  border-bottom: 1px solid black;
}

.header {
  display: flex;
  justify-content: space-between;
}

.header .left {
  width: 80%;
}

.header .right {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.right p {
  font-size: 12px;
}

.report-info {
  display: flex;
  margin-top: 1rem;
  justify-content: space-between;
}

.report-info p {
  font-style: italic;
}

.report-info .kv {
  padding: 0 5px;
  height: fit-content;
  border: 1px solid black;
}

table {
  border-bottom: 1px solid black;
}

table th {
  text-align: left;
}

footer {
  display: flex;
  justify-content: space-between;
}

.sign p {
  margin-right: 150px;
}
</style>
